import { configureClient } from '@/api/client';
import type { AuthUser } from './types';

export const STORAGE_KEY = 'dispo.currentUser';
export const SESSION_EXPIRED_EVENT = 'dispo:session-expired';

export function readStoredUser(): AuthUser | null {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        return raw ? (JSON.parse(raw) as AuthUser) : null;
    } catch {
        return null;
    }
}

export function writeStoredUser(user: AuthUser | null): void {
    if (user) {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(user));
    } else {
        localStorage.removeItem(STORAGE_KEY);
    }
}

// localStorage is the single source of truth for the token, so the client never sees a stale
// value regardless of React effect order. A 401 on a token-carrying request clears it and
// tells the AuthProvider through a window event.
configureClient({
    getToken: () => readStoredUser()?.token ?? null,
    onUnauthorized: () => {
        writeStoredUser(null);
        window.dispatchEvent(new Event(SESSION_EXPIRED_EVENT));
    },
});
